/**
 * Force-close a Bootstrap modal synchronously.
 * Using modal('hide') alone is unreliable when a DOM re-render fires
 * immediately after (e.g. chat_content_render), because Bootstrap's async
 * hide animation never completes its cleanup, leaving a stale
 * `.modal-backdrop` in the DOM and `overflow:hidden` on <body>.
 */
export function forceCloseModal($modal) {
    if (!$modal || !$modal.length || !$modal.is(':visible')) {
        return;
    }

    // Let Bootstrap attempt a clean hide first (fires 'hidden.bs.modal').
    try {
        $modal.modal('hide');
    } catch (e) {
        // ignore
    }

    // Immediately force-clean regardless of animation state.
    $modal.removeClass('show').hide().removeAttr('aria-modal').attr('aria-hidden', 'true');
    $('body').removeClass('modal-open').css({ overflow: '', paddingRight: '' });
    $('.modal-backdrop').remove();
}
